import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {type} = jsonNode;
  const needed = type === 'CommerceCheckoutFieldGroup';

  return {
    needed,
    logData: {
      msg: 'Legacy E-commerce element needs type change to Block',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.type = 'Block';
    },
  };
};
